module.exports = __webpack_public_path__ + "static/media/8.ac075270.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/biquad/8.png
// module id = 1529
// module chunks = 0